import React from 'react';
import { Container, Typography, Box, Paper, Divider } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const TermsAndConditions = ({ language = 'si' }) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';

    const content = {
        en: {
            title: "Terms and Conditions",
            intro: "These Terms and Conditions [“Terms”] govern your use of the website Yuwathipathi.lk [“Site”]. By accessing or using the Site, you agree to comply with and be legally bound by these Terms, including our Privacy Policy. Please read them carefully.",

            agreementTitle: "AGREEMENT",
            agreementText: "By accessing and using Yuwathipathi.lk, you [“You”] agree to be bound by these Terms and Conditions and our Privacy Policy. If you don't agree, please do not use the Site or its services. We may amend these Terms from time to time. Continued use of the Site after amendments constitutes acceptance of the revised Terms.",

            servicesTitle: "SERVICES",
            onlineServicesTitle: "Online Services:",
            onlineServicesText: "Yuwathipathi.lk provides online advertising space and services for a nominal fee, allowing You to post personal or third-party content (with their consent) to seek a prospective matrimonial partner [“Matrimonial Advertisement”].",
            disclaimerTitle: "Important Disclaimer on Matchmaking:",
            disclaimerText: "Yuwathipathi.lk does not guarantee that any marriage, relationship, or successful matchmaking will result from the use of our services. Our role is limited to providing a platform for advertising and discovery. We do not interfere with, participate in, or influence any post-match communications or decisions. Any conversations or outcomes following a match are entirely the responsibility of the individuals involved.",

            eligibilityTitle: "ELIGIBILITY CRITERIA",
            eligibilityText: "You (and any third party you represent) must:",
            eligibilityList: [
                "Be at least 18 years old;",
                "Not be a minor under applicable laws;",
                "Be legally eligible to marry under relevant laws."
            ],

            advertisingTitle: "ADVERTISING CONTENT",
            advertisingText1: "You are solely responsible for the accuracy, legality, and completeness of the content [“Content”] in your Matrimonial Advertisement.",
            advertisingText2: "Content includes personal information, images, and other material you upload.",
            advertisingText3: "All uploaded images will carry a watermark for identification and to deter misuse.",
            advertisingText4: "We reserve the right to edit or remove any content that breaches these Terms or affects the integrity of Yuwathipathi.lk without prior notice.",
            prohibitedTitle: "Prohibited Content Includes (but is not limited to):",
            prohibitedList: [
                "False, misleading, or deceptive information;",
                "Offensive or discriminatory content;",
                "Content violating third-party rights (e.g., copyright, privacy);",
                "Unlawful content under applicable laws."
            ],

            responsibilitiesTitle: "USER RESPONSIBILITIES",
            responsibilitiesList: [
                "You may use the Site only for purposes authorized under these Terms.",
                "You are responsible for ensuring that any content you provide complies with all applicable laws.",
                "You must promptly correct any inaccuracies in your content, and we may verify these corrections before updating them on the Site."
            ],

            representationsTitle: "REPRESENTATIONS & WARRANTIES",
            representationsText: "By using Yuwathipathi.lk, you represent and warrant that:",
            representationsList: [
                "You meet the eligibility criteria stated above.",
                "Any third party represented by you has consented to your actions on their behalf.",
                "All information provided is truthful, accurate, current, and legally valid.",
                "You and any third party are not restricted by law or third-party contracts from using or authorizing use of personal information for Yuwathipathi.lk."
            ],

            confidentialityTitle: "CONFIDENTIALITY",
            confidentialityText: "Your personal information (and that of any third party) will be kept confidential unless:",
            confidentialityList: [
                "You provide consent;",
                "Disclosure is required by law;",
                "Disclosure is necessary to protect our rights or the rights of other users."
            ],

            privacyTitle: "PRIVACY POLICY",
            privacyText: "We process personal information in accordance with our Privacy Policy. By using Yuwathipathi.lk, you consent to our data practices, including the use of cookies and similar technologies.",

            withdrawalTitle: "WITHDRAWAL & CANCELLATION",
            withdrawalList: [
                "You may unpublish your advertisement at any time.",
                "To remove all content from our databases, please email us with your request.",
                "Refunds: Advertising fees are non-refundable once the advertisement is published. Refunds may be requested during the review period, prior to publication."
            ],

            ipTitle: "INTELLECTUAL PROPERTY",
            ipText: "All content, design, software, and trademarks on Yuwathipathi.lk are owned or licensed by us and protected by intellectual property laws. No content may be copied, distributed, or reused without our written permission.",

            disclaimerMainTitle: "DISCLAIMER",
            disclaimerMainText: "We make no guarantees about the Site’s functionality or the accuracy of the content. We are not liable for:",
            disclaimerMainList: [
                "Errors or omissions on the Site;",
                "Site unavailability;",
                "Your use of the Site or content;",
                "Any issues related to third-party software used in connection with the Site."
            ],

            indemnityTitle: "INDEMNITY",
            indemnityText: "You agree to indemnify and hold harmless Yuwathipathi.lk, its officers, and employees against any third-party claims, damages, or losses arising from:",
            indemnityList: [
                "Your violation of these Terms;",
                "Your wrongful or negligent conduct on Yuwathipathi.lk."
            ],

            terminationTitle: "TERMINATION",
            terminationText: "This Agreement may be terminated:",
            terminationList: [
                "Upon expiry of the advertisement term;",
                "If you withdraw your advertisement;",
                "Upon breach of these Terms by you or your represented third party."
            ],
            consequencesTitle: "Consequences:",
            consequencesText: "We may terminate your access to Yuwathipathi.lk and delete your content without notice.",

            amendmentsTitle: "AMENDMENTS",
            amendmentsText: "These Terms may be revised at any time. Revised Terms take effect immediately upon posting. Continued use of the Site after revisions implies acceptance of the new Terms.",

            contactTitle: "CONTACT US",
            contactText: "If you have any questions about these Terms and Conditions, please contact us at:",
            phoneLabel: "Phone:",
            emailLabel: "Email:",
            copyright: "© 2024 Yuwathipathi",
            rightsReserved: "All rights reserved."
        },
        si: {
            title: "නියමයන් සහ කොන්දේසි",
            intro: "මෙම නියමයන් සහ කොන්දේසි [\"නියමයන්\"] යුවතිපති.lk [\"වෙබ් අඩවිය\"] භාවිතා කිරීම පාලනය කරයි. වෙබ් අඩවියට ප්‍රවේශ වීමෙන් හෝ භාවිතා කිරීමෙන්, අපගේ රහස්‍යතා ප්‍රතිපත්තිය ඇතුළුව මෙම නියමයන්ට අනුකූල වීමට සහ නීත්‍යානුකූලව බැඳී සිටීමට ඔබ එකඟ වේ. කරුණාකර ඒවා හොඳින් කියවන්න.",

            agreementTitle: "ගිවිසුම",
            agreementText: "යුවතිපති.lk වෙත ප්‍රවේශ වීමෙන් සහ භාවිතා කිරීමෙන්, ඔබ [\"ඔබ\"] මෙම නියමයන් සහ කොන්දේසි සහ අපගේ රහස්‍යතා ප්‍රතිපත්තියට බැඳී සිටීමට එකඟ වේ. ඔබ එකඟ නොවන්නේ නම්, කරුණාකර වෙබ් අඩවිය හෝ එහි සේවාවන් භාවිතා නොකරන්න. අපි වරින් වර මෙම නියමයන් සංශෝධනය කළ හැක. සංශෝධනවලින් පසුව වෙබ් අඩවිය අඛණ්ඩව භාවිතා කිරීම යනු සංශෝධිත නියමයන් පිළිගැනීමයි.",

            servicesTitle: "සේවාවන්",
            onlineServicesTitle: "මාර්ගගත සේවාවන්:",
            onlineServicesText: "යුවතිපති.lk නාමික ගාස්තුවක් සඳහා මාර්ගගත වෙළඳ දැන්වීම් ඉඩ සහ සේවාවන් සපයයි, එමඟින් අනාගත විවාහ සහකරුවෙකු [\"විවාහ දැන්වීම\"] සෙවීම සඳහා පුද්ගලික හෝ තෙවන පාර්ශවීය අන්තර්ගතයන් (ඔවුන්ගේ කැමැත්ත ඇතිව) පළ කිරීමට ඔබට ඉඩ සලසයි.",
            disclaimerTitle: "ගැලපීම් පිළිබඳ වැදගත් වියාචනය:",
            disclaimerText: "යුවතිපති.lk අපගේ සේවාවන් භාවිතා කිරීමෙන් කිසියම් විවාහයක්, සම්බන්ධතාවයක් හෝ සාර්ථක ගැලපීමක් සිදුවන බවට සහතික නොවේ. අපගේ කාර්යභාරය දැන්වීම් සහ සොයාගැනීම් සඳහා වේදිකාවක් සැපයීමට සීමා වේ. ගැලපීමකින් පසු සිදුවන කිසිදු සන්නිවේදනයකට හෝ තීරණයකට අපි මැදිහත් නොවෙමු, සහභාගී නොවෙමු, හෝ බලපෑම් නොකරමු. ගැලපීමකින් පසුව සිදුවන ඕනෑම සංවාදයක් හෝ ප්‍රතිඵලයක් සම්පූර්ණයෙන්ම අදාළ පුද්ගලයින්ගේ වගකීම වේ.",

            eligibilityTitle: "සුදුසුකම් නිර්ණායක",
            eligibilityText: "ඔබ (සහ ඔබ නියෝජනය කරන ඕනෑම තෙවන පාර්ශවයක්) අනිවාර්යයෙන්ම:",
            eligibilityList: [
                "වයස අවුරුදු 18 සම්පූර්ණ වී තිබිය යුතුය;",
                "අදාළ නීති යටතේ බාල වයස්කරුවෙකු නොවිය යුතුය;",
                "අදාළ නීති යටතේ විවාහ වීමට නීත්‍යානුකූලව සුදුසුකම් ලබා තිබිය යුතුය."
            ],

            advertisingTitle: "දැන්වීම් අන්තර්ගතය",
            advertisingText1: "ඔබගේ විවාහ දැන්වීමේ අන්තර්ගතයේ [\"අන්තර්ගතය\"] නිරවද්‍යතාවය, නීත්‍යානුකූලභාවය සහ සම්පූර්ණත්වය සඳහා ඔබ සම්පූර්ණයෙන්ම වගකිව යුතුය.",
            advertisingText2: "අන්තර්ගතයට පුද්ගලික තොරතුරු, පින්තූර සහ ඔබ උඩුගත කරන වෙනත් ද්‍රව්‍ය ඇතුළත් වේ.",
            advertisingText3: "උඩුගත කරන ලද සියලුම පින්තූර හඳුනා ගැනීම සහ අවභාවිතය වැළැක්වීම සඳහා දිය සලකුණක් (watermark) සහිතව ඇත.",
            advertisingText4: "මෙම නියමයන් උල්ලංඝනය කරන හෝ යුවතිපති.lk හි අඛණ්ඩතාවයට බලපාන ඕනෑම අන්තර්ගතයක් පූර්ව දැනුම්දීමකින් තොරව සංස්කරණය කිරීමට හෝ ඉවත් කිරීමට අපට අයිතිය ඇත.",
            prohibitedTitle: "තහනම් අන්තර්ගතයට ඇතුළත් වන්නේ (නමුත් මේවාට සීමා නොවේ):",
            prohibitedList: [
                "අසත්‍ය, නොමඟ යවන හෝ රැවටිලිකාර තොරතුරු;",
                "අපහාසාත්මක හෝ වෙනස් කොට සැලකීමේ අන්තර්ගතය;",
                "තෙවන පාර්ශවීය අයිතිවාසිකම් උල්ලංඝනය කරන අන්තර්ගතය (උදා: ප්‍රකාශන හිමිකම, පෞද්ගලිකත්වය);",
                "අදාළ නීති යටතේ නීති විරෝධී අන්තර්ගතය."
            ],

            responsibilitiesTitle: "පරිශීලක වගකීම්",
            responsibilitiesList: [
                "ඔබට වෙබ් අඩවිය භාවිතා කළ හැක්කේ මෙම නියමයන් යටතේ අවසර දී ඇති අරමුණු සඳහා පමණි.",
                "ඔබ සපයන ඕනෑම අන්තර්ගතයක් අදාළ සියලුම නීතිවලට අනුකූල බව සහතික කිරීම සඳහා ඔබ වගකිව යුතුය.",
                "ඔබගේ අන්තර්ගතයේ ඇති ඕනෑම සාවද්‍යතාවයක් ඔබ වහාම නිවැරදි කළ යුතු අතර, ඒවා වෙබ් අඩවියේ යාවත්කාලීන කිරීමට පෙර අපට එම නිවැරදි කිරීම් තහවුරු කළ හැක."
            ],

            representationsTitle: "නියෝජනයන් සහ සහතික කිරීම්",
            representationsText: "යුවතිපති.lk භාවිතා කිරීමෙන්, ඔබ නියෝජනය සහ සහතික කරන්නේ:",
            representationsList: [
                "ඔබ ඉහත සඳහන් සුදුසුකම් නිර්ණායක සපුරාලන බව.",
                "ඔබ විසින් නියෝජනය කරනු ලබන ඕනෑම තෙවන පාර්ශවයක් ඔවුන් වෙනුවෙන් ඔබ කරන ක්‍රියාවන් සඳහා කැමැත්ත ලබා දී ඇති බව.",
                "ලබා දී ඇති සියලුම තොරතුරු සත්‍ය, නිවැරදි, වත්මන් සහ නීත්‍යානුකූලව වලංගු බව.",
                "යුවතිපති.lk සඳහා පුද්ගලික තොරතුරු භාවිතා කිරීමට හෝ භාවිතා කිරීමට අවසර දීමට නීතියෙන් හෝ තෙවන පාර්ශවීය ගිවිසුම් මගින් ඔබට සහ ඕනෑම තෙවන පාර්ශවයකට බාධාවක් නොමැති බව."
            ],

            confidentialityTitle: "රහස්‍යභාවය",
            confidentialityText: "ඔබගේ පුද්ගලික තොරතුරු (සහ ඕනෑම තෙවන පාර්ශවයක) රහසිගතව තබනු ලැබේ, පහත අවස්ථා හැර:",
            confidentialityList: [
                "ඔබ කැමැත්ත ලබා දෙන්නේ නම්;",
                "නීතියෙන් හෙළිදරව් කිරීම අවශ්‍ය නම්;",
                "අපගේ අයිතිවාසිකම් හෝ වෙනත් පරිශීලකයින්ගේ අයිතිවාසිකම් ආරක්ෂා කිරීමට හෙළිදරව් කිරීම අවශ්‍ය නම්."
            ],

            privacyTitle: "රහස්‍යතා ප්‍රතිපත්තිය",
            privacyText: "අපගේ රහස්‍යතා ප්‍රතිපත්තියට අනුකූලව අපි පුද්ගලික තොරතුරු සකසන්නෙමු. යුවතිපති.lk භාවිතා කිරීමෙන්, කුකීස් සහ සමාන තාක්ෂණයන් භාවිතා කිරීම ඇතුළුව අපගේ දත්ත භාවිතයන්ට ඔබ එකඟ වේ.",

            withdrawalTitle: " ඉල්ලා අස්කර ගැනීම සහ අවලංගු කිරීම",
            withdrawalList: [
                "ඔබට ඕනෑම වේලාවක ඔබේ දැන්වීම ප්‍රකාශයට පත් කිරීම අවලංගු කළ හැක (Unpublish).",
                "අපගේ දත්ත සමුදායන්ගෙන් සියලුම අන්තර්ගතයන් ඉවත් කිරීමට, කරුණාකර ඔබගේ ඉල්ලීම සමඟ අපට විද්‍යුත් තැපැල් කරන්න.",
                "මුදල් ආපසු ගෙවීම්: දැන්වීම ප්‍රකාශයට පත් කළ පසු වෙළඳ දැන්වීම් ගාස්තු ආපසු ගෙවනු නොලැබේ. ප්‍රකාශනයට පෙර, සමාලෝචන කාල සීමාව තුළ මුදල් ආපසු ගෙවීම් ඉල්ලා සිටිය හැක."
            ],

            ipTitle: "බුද්ධිමය දේපල (Intellectual Property)",
            ipText: "යුවතිපති.lk හි ඇති සියලුම අන්තර්ගතයන්, සැලසුම්, මෘදුකාංග සහ වෙළඳ ලකුණු අප සතු හෝ බලපත්‍ර ලබා ඇති අතර බුද්ධිමය දේපල නීති මගින් ආරක්ෂා කර ඇත. අපගේ ලිඛිත අවසරයකින් තොරව කිසිදු අන්තර්ගතයක් පිටපත් කිරීම, බෙදා හැරීම හෝ නැවත භාවිතා කිරීම නොකළ යුතුය.",

            disclaimerMainTitle: "වියාචනය (Disclaimer)",
            disclaimerMainText: "වෙබ් අඩවියේ ක්‍රියාකාරිත්වය හෝ අන්තර්ගතයේ නිරවද්‍යතාවය පිළිබඳව අපි කිසිදු සහතිකයක් ලබා නොදෙමු. පහත සඳහන් දෑ සඳහා අපි වගකිව යුතු නොවේ:",
            disclaimerMainList: [
                "වෙබ් අඩවියේ ඇති දෝෂ හෝ අඩුපාඩු;",
                "වෙබ් අඩවිය ලබා ගත නොහැකි වීම;",
                "ඔබ වෙබ් අඩවිය හෝ අන්තර්ගතය භාවිතා කිරීම;",
                "වෙබ් අඩවිය හා සම්බන්ධව භාවිතා කරන තෙවන පාර්ශවීය මෘදුකාංග සම්බන්ධ ඕනෑම ගැටළුවක්."
            ],

            indemnityTitle: "වන්දි ගෙවීම",
            indemnityText: "පහත සඳහන් දෑ නිසා ඇතිවන ඕනෑම තෙවන පාර්ශවීය හිමිකම්, හානි, හෝ පාඩු වලට එරෙහිව යුවතිපති.lk, එහි නිලධාරීන් සහ සේවකයින්ට වන්දි ගෙවීමට සහ ඔවුන්ව එම වගකීම් වලින් නිදහස් කිරීමට ඔබ එකඟ වේ:",
            indemnityList: [
                "ඔබ මෙම නියමයන් උල්ලංඝනය කිරීම;",
                "යුවතිපති.lk හි ඔබගේ වැරදි හෝ නොසැලකිලිමත් හැසිරීම."
            ],

            terminationTitle: "අවසන් කිරීම",
            terminationText: "මෙම ගිවිසුම අවසන් කළ හැක:",
            terminationList: [
                "ප්‍රචාරණ කාල සීමාව ඉකුත් වූ පසු;",
                "ඔබ ඔබේ දැන්වීම ඉල්ලා අස්කර ගන්නේ නම්;",
                "ඔබ හෝ ඔබ නියෝජනය කරන තෙවන පාර්ශවය මෙම නියමයන් උල්ලංඝනය කිරීමෙන් පසු."
            ],
            consequencesTitle: "ප්‍රතිවිපාක:",
            consequencesText: "දැනුම් දීමකින් තොරව යුවතිපති.lk වෙත ඔබගේ ප්‍රවේශය අවසන් කිරීමට සහ ඔබගේ අන්තර්ගතය මකා දැමීමට අපට හැකිය.",

            amendmentsTitle: "සංශෝධන",
            amendmentsText: "මෙම නියමයන් ඕනෑම වේලාවක සංශෝධනය කළ හැක. සංශෝධිත නියමයන් පළ කළ වහාම ක්‍රියාත්මක වේ. සංශෝධනවලින් පසුව වෙබ් අඩවිය අඛණ්ඩව භාවිතා කිරීම යනු නව නියමයන් පිළිගැනීමයි.",

            contactTitle: "අප අමතන්න",
            contactText: "මෙම නියමයන් සහ කොන්දේසි පිළිබඳව ඔබට යම් ගැටළුවක් ඇත්නම්, කරුණාකර අප අමතන්න:",
            phoneLabel: "දුරකථන:",
            emailLabel: "විද්‍යුත් තැපෑල:",
            copyright: "© 2024 යුවතිපති",
            rightsReserved: "සියලුම හිමිකම් ඇවිරිණි."
        }
    };

    const t = content[language] || content.si;

    return (
        <Box
            sx={{
                backgroundColor: isDark ? 'background.default' : '#f5f5f5',
                minHeight: '100vh',
                py: 4
            }}
        >
            <Container maxWidth="md">
                <Paper elevation={3} sx={{ p: 4, borderRadius: 2 }}>
                    <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main', textAlign: 'center' }}>
                        {t.title}
                    </Typography>

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="body1" paragraph>
                            {t.intro}
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {t.agreementTitle}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t.agreementText}
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {t.servicesTitle}
                        </Typography>

                        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', mt: 2 }}>
                            {t.onlineServicesTitle}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t.onlineServicesText}
                        </Typography>

                        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', mt: 2 }}>
                            {t.disclaimerTitle}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t.disclaimerText}
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {t.eligibilityTitle}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t.eligibilityText}
                        </Typography>
                        <ul>
                            {t.eligibilityList.map((item, index) => (
                                <li key={index}><Typography variant="body1">{item}</Typography></li>
                            ))}
                        </ul>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {t.advertisingTitle}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t.advertisingText1}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t.advertisingText2}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t.advertisingText3}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t.advertisingText4}
                        </Typography>

                        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', mt: 2 }}>
                            {t.prohibitedTitle}
                        </Typography>
                        <ul>
                            {t.prohibitedList.map((item, index) => (
                                <li key={index}><Typography variant="body1">{item}</Typography></li>
                            ))}
                        </ul>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {t.responsibilitiesTitle}
                        </Typography>
                        <ul>
                            {t.responsibilitiesList.map((item, index) => (
                                <li key={index}><Typography variant="body1">{item}</Typography></li>
                            ))}
                        </ul>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {t.representationsTitle}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t.representationsText}
                        </Typography>
                        <ul>
                            {t.representationsList.map((item, index) => (
                                <li key={index}><Typography variant="body1">{item}</Typography></li>
                            ))}
                        </ul>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {t.confidentialityTitle}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t.confidentialityText}
                        </Typography>
                        <ul>
                            {t.confidentialityList.map((item, index) => (
                                <li key={index}><Typography variant="body1">{item}</Typography></li>
                            ))}
                        </ul>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {t.privacyTitle}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t.privacyText}
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {t.withdrawalTitle}
                        </Typography>
                        <ul>
                            {t.withdrawalList.map((item, index) => (
                                <li key={index}><Typography variant="body1">{item}</Typography></li>
                            ))}
                        </ul>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {t.ipTitle}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t.ipText}
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {t.disclaimerMainTitle}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t.disclaimerMainText}
                        </Typography>
                        <ul>
                            {t.disclaimerMainList.map((item, index) => (
                                <li key={index}><Typography variant="body1">{item}</Typography></li>
                            ))}
                        </ul>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {t.indemnityTitle}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t.indemnityText}
                        </Typography>
                        <ul>
                            {t.indemnityList.map((item, index) => (
                                <li key={index}><Typography variant="body1">{item}</Typography></li>
                            ))}
                        </ul>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {t.terminationTitle}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t.terminationText}
                        </Typography>
                        <ul>
                            {t.terminationList.map((item, index) => (
                                <li key={index}><Typography variant="body1">{item}</Typography></li>
                            ))}
                        </ul>
                        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold', mt: 2 }}>
                            {t.consequencesTitle}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t.consequencesText}
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {t.amendmentsTitle}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t.amendmentsText}
                        </Typography>
                    </Box>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
                            {t.contactTitle}
                        </Typography>
                        <Typography variant="body1" paragraph>
                            {t.contactText}
                        </Typography>
                        <Typography variant="body1">
                            <strong>{t.phoneLabel}</strong> +94 75 773 4313 | +94 72 588 1874<br />
                            <strong>{t.emailLabel}</strong> yuwathipathisl@gmail.com
                        </Typography>
                    </Box>

                    <Box sx={{ mt: 5, textAlign: 'center', color: 'text.secondary' }}>
                        <Typography variant="body2">
                            {t.copyright}<br />
                            {t.rightsReserved}
                        </Typography>
                    </Box>

                </Paper>
            </Container>
        </Box>
    );
};

export default TermsAndConditions;
